import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { applyDocumentIdentity, storedDocumentAuthType } from './document-identity.js';
import './theme.css';

applyDocumentIdentity(storedDocumentAuthType());

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
